import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { usePageView } from '@/analytics/pageTypes';
import { Trans, useTranslation } from 'react-i18next';
import { Layout } from '@/components/layout';
import Hero from '@/sections/Hero';
import type { GetStaticProps } from 'next';
import { getIntlProps, type IntlProps } from '@/utils/intl';
import { LINKS } from '@/constants/links';
import { Link } from '@/components/links';
import { SectionDelimiter } from '@/components/SectionDelimiter';
import Benefits from '@/sections/exchangeRate/Benefits';
import Table from '@/sections/exchangeRate/Table';
import FAQs from '@/sections/exchangeRate/FAQs';
import { FaqIntro } from '@/sections/FaqIntro';
import MoreInfo from '@/sections/MoreInfo';
import IconDeferredPayment from '@/assets/icons/heroIcons/Deferred-payment.svg';
import IconThird from '@/assets/icons/heroIcons/Icon-third.svg';
import IconCard from '@/assets/icons/heroIcons/Card-front.svg';
import { getPageBannerBySlug, PageBanner } from '@/api/sanity/pageBanners';
import { SeoHeader } from '@/components/SeoHeader';
import { isAllowedRoute } from '@/lang/pagesConfig';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
import IconMaxi from '@/assets/icons/heroIcons/Maxi.svg';
interface Props extends IntlProps {
  pageBanner: PageBanner | null;
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function Page(t0) {
  const $ = _c(73);
  const {
    pageBanner,
    menuPromoBanners
  } = t0;
  usePageView("exchange-rate");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["core", "exchangeRate"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== t) {
    t2 = t("exchangeRate:seo.title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("exchangeRate:seo.description");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <SeoHeader title={t2} description={t3} />;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = pageBanner?.videoId;
  let t6;
  if ($[8] !== pageBanner?.title || $[9] !== t) {
    t6 = pageBanner?.title ?? t("exchangeRate:heroSection.title");
    $[8] = pageBanner?.title;
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== pageBanner?.text || $[12] !== t) {
    t7 = pageBanner?.text ?? <Trans i18nKey="exchangeRate:heroSection.paragraph" t={t}><Link to={LINKS().card} testId="exchangeRateHeroCard" analyticsParam="exchangeRateHeroCard" /></Trans>;
    $[11] = pageBanner?.text;
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== pageBanner || $[15] !== t) {
    t8 = pageBanner ? pageBanner.buttons : [{
      ariaLabel: t("exchangeRate:heroSection.buttonPrimary"),
      label: t("exchangeRate:heroSection.buttonPrimary"),
      to: LINKS().card,
      testId: "exchangeRateHeroPrimaryCTA",
      analyticsParam: "exchangeRateHeroPrimaryCTA",
      variant: "primary"
    }];
    $[14] = pageBanner;
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const t9 = pageBanner?.image?.url ?? "/images/sections/card/hero/cs/hero.png";
  let t10;
  if ($[17] !== pageBanner?.image?.alt || $[18] !== t) {
    t10 = pageBanner?.image?.alt ?? t("exchangeRate:heroSection.title");
    $[17] = pageBanner?.image?.alt;
    $[18] = t;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t9) {
    t11 = {
      url: t9,
      alt: t10
    };
    $[20] = t10;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  const t12 = pageBanner?.variant || "mockupMobile";
  let t13;
  if ($[23] !== t11 || $[24] !== t12 || $[25] !== t5 || $[26] !== t6 || $[27] !== t7 || $[28] !== t8) {
    t13 = <Hero videoId={t5} title={t6} text={t7} buttons={t8} image={t11} variant={t12} />;
    $[23] = t11;
    $[24] = t12;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="bg-blue-50"><SectionDelimiter color="bg-blue-100" background="bg-transparent" /></div>;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  let t16;
  let t17;
  let t18;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="relative z-30 bg-blue-100 px-4"><Benefits /><Table /></div>;
    t16 = <SectionDelimiter color="bg-blue-50" background="bg-blue-100" />;
    t17 = <FAQs />;
    t18 = <SectionDelimiter color="bg-blue-100" background="bg-blue-50" />;
    $[31] = t15;
    $[32] = t16;
    $[33] = t17;
    $[34] = t18;
  } else {
    t15 = $[31];
    t16 = $[32];
    t17 = $[33];
    t18 = $[34];
  }
  let t19;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <div className="py-10 lg:py-20"><FaqIntro link={LINKS().faq} /></div>;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <IconDeferredPayment className="fillButtonIcon" />;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t) {
    t21 = t("core:products.deferredPayment");
    $[37] = t;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = LINKS();
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== t21) {
    t23 = {
      analyticsParam: "exchangeRateMoreInfoDeferredPayment",
      icon: t20,
      testId: "exchangeRateMoreInfoDeferredPayment",
      title: t21,
      to: t22.deferredPayment
    };
    $[40] = t21;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <IconMaxi className="fillButtonIcon" />;
    $[42] = t24;
  } else {
    t24 = $[42];
  }
  let t25;
  if ($[43] !== t) {
    t25 = t("core:products.revolving");
    $[43] = t;
    $[44] = t25;
  } else {
    t25 = $[44];
  }
  let t26;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = LINKS();
    $[45] = t26;
  } else {
    t26 = $[45];
  }
  let t27;
  if ($[46] !== t25) {
    t27 = {
      analyticsParam: "exchangeRateMoreInfoRevolvingApplication",
      icon: t24,
      testId: "exchangeRateMoreInfoRevolvingApplication",
      title: t25,
      to: t26.revolving
    };
    $[46] = t25;
    $[47] = t27;
  } else {
    t27 = $[47];
  }
  let t28;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <IconThird className="fillButtonIcon" />;
    $[48] = t28;
  } else {
    t28 = $[48];
  }
  let t29;
  if ($[49] !== t) {
    t29 = t("core:products.payInThree");
    $[49] = t;
    $[50] = t29;
  } else {
    t29 = $[50];
  }
  let t30;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = LINKS();
    $[51] = t30;
  } else {
    t30 = $[51];
  }
  let t31;
  if ($[52] !== t29) {
    t31 = {
      analyticsParam: "exchangeRateMoreInfoPayInThree",
      icon: t28,
      testId: "exchangeRateMoreInfoPayInThree",
      title: t29,
      to: t30.payInThree
    };
    $[52] = t29;
    $[53] = t31;
  } else {
    t31 = $[53];
  }
  let t32;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <IconCard className="fillButtonIcon" />;
    $[54] = t32;
  } else {
    t32 = $[54];
  }
  let t33;
  if ($[55] !== t) {
    t33 = t("core:products.card");
    $[55] = t;
    $[56] = t33;
  } else {
    t33 = $[56];
  }
  let t34;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = LINKS();
    $[57] = t34;
  } else {
    t34 = $[57];
  }
  let t35;
  if ($[58] !== t33) {
    t35 = {
      analyticsParam: "exchangeRateMoreInfoCard",
      icon: t32,
      testId: "exchangeRateMoreInfoCard",
      title: t33,
      to: t34.card
    };
    $[58] = t33;
    $[59] = t35;
  } else {
    t35 = $[59];
  }
  let t36;
  if ($[60] !== t23 || $[61] !== t27 || $[62] !== t31 || $[63] !== t35) {
    t36 = <div className="relative z-10">{t19}<MoreInfo buttons={[t23, t27, t31, t35]} /></div>;
    $[60] = t23;
    $[61] = t27;
    $[62] = t31;
    $[63] = t35;
    $[64] = t36;
  } else {
    t36 = $[64];
  }
  let t37;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <div className="bgCircle absolute right-0 bottom-0 translate-x-1/4 translate-y-1/4 rotate-180" />;
    $[65] = t37;
  } else {
    t37 = $[65];
  }
  let t38;
  if ($[66] !== t36) {
    t38 = <div className="relative overflow-hidden bg-blue-100">{t36}{t37}</div>;
    $[66] = t36;
    $[67] = t38;
  } else {
    t38 = $[67];
  }
  let t39;
  if ($[68] !== menuPromoBanners || $[69] !== t13 || $[70] !== t38 || $[71] !== t4) {
    t39 = <Layout menuPromoBanners={menuPromoBanners}>{t4}{t13}{t14}{t15}{t16}{t17}{t18}{t38}</Layout>;
    $[68] = menuPromoBanners;
    $[69] = t13;
    $[70] = t38;
    $[71] = t4;
    $[72] = t39;
  } else {
    t39 = $[72];
  }
  return t39;
}
export const getStaticProps = (async ctx => {
  const isAllowed = isAllowedRoute('kurzovni-listek');
  if (!isAllowed) {
    return {
      notFound: true
    };
  }
  return {
    props: {
      pageBanner: await getPageBannerBySlug('exchange-rate'),
      menuPromoBanners: await getAllPageMenuPromoBanners(),
      ...(await getIntlProps(ctx, ['core', 'exchangeRate']))
    }
  };
}) satisfies GetStaticProps<Props>;